import {Directive, Input} from '@angular/core';
import {AbstractControl, NG_VALIDATORS, ValidationErrors, Validator} from '@angular/forms';

@Directive({
  // tslint:disable-next-line:directive-selector
  selector: '[requireObject]',
  providers: [{provide: NG_VALIDATORS, useExisting: RequireObjectDirective, multi: true}]
})
export class RequireObjectDirective implements Validator {
  @Input() initialValue: string;

  validate(control: AbstractControl): ValidationErrors | null {
    const selection: any = control.value;
    if (typeof selection === 'string' && selection !== this.initialValue) {
      return {incorrect: true};
    }
    return null;
  }

}
